import React from 'react';

import Portrait from "./Portrait";

import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import { isIPhone } from "@/modules/iOSDetection";
import { mouseOver, mouseLeave } from "@/modules/mouseInteractions";
import { rouletteReds, betGroupProp } from "@/modules/commonMobile";
import { IGameTableType } from "@/types/GlobalTypes";

import "./index.scss";

//Roulette
export default class P7 extends React.Component<IGameTableType> {
	state = { activeHover: "" };

	render() {
		const { langdata, showHiddenMultibet, portrait } = this.props;
		const multibetBackground = showHiddenMultibet ? "rgba(255, 255, 0, 0.5)" : "transparent";

		const win = this.props.win ? Number(this.props.win) : null;
		const reds = rouletteReds;

		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		if (portrait)
			return <Portrait {...this.props} />;

		return (
			<div className="sl-table">
				<div className="sl-table-cell table-p7">
					<div className="w-8 sides">
						<div className={"sl-bet sl-green-lighten w-100 solo " + (this.state.activeHover.indexOf("00") >= 0 ? " sl-bet-hover" : " sl-green-lighten") +
								((win === 0) ? " sl-yellow-alternating" : "")}
							// bet="00" pcode={this.props.pcode} group="n"
							{...betGroupProp(this, "00", "n")}
							onClick={this.props.insertBet}>
							0
						<Chips {...commonChipProps} betKey="00+n" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["00+n"]} />
						</div>
					</div>
					<div className="w-83 mainbox-bet">
						<div className="dp-flex">
							<div className="w-33">
								{
									["03", "06", "09", "12", "02", "05", "08", "11", "01", "04", "07", "10"].map(item => {
										//splits the number with the colour letter
										const num = Number(item);
										let styles = "sl-bet " + (reds.indexOf(num) >= 0 ? "sl-red-lighten" : "sl-black-lighten");
										if (
											// (this.state.activeHover.length === 5 || this.state.activeHover.split(",").length === 4)
											(this.state.activeHover.indexOf(item) >= 0 && this.state.activeHover.indexOf(" ") < 0) ||
											(this.state.activeHover === "1st 12") ||
											(this.state.activeHover === "odd" && num % 2) ||
											(this.state.activeHover === "even" && !(num % 2)) ||
											(this.state.activeHover === "red" && reds.indexOf(num) >= 0) ||
											(this.state.activeHover === "black" && reds.indexOf(num) < 0) ||
											(this.state.activeHover === "1 to 18" && num <= 18) ||
											(this.state.activeHover === "19 to 36" && num >= 19) ||
											(this.state.activeHover === "3rd Row" && num % 3 === 0) ||
											(this.state.activeHover === "2nd Row" && num % 3 === 2) ||
											(this.state.activeHover === "1st Row" && num % 3 === 1))
											styles += " sl-bet-hover";
										if (win === +item)
											styles += " sl-yellow-alternating";

										return (
											<div key={`${item}+n`} className={styles}
												// bet={item} pcode={this.props.pcode} group="n"
												{...betGroupProp(this, item, "n")}
												onClick={this.props.insertBet}>
												{num}

												<Chips {...commonChipProps} betKey={item + "+n"} />
												<Tooltip {...commonTooltipProps} bet={this.props.bets[item + "+n"]} />
											</div>
										);
									})
								}
							</div>

							<div className="w-33">
								{
									["15", "18", "21", "24", "14", "17", "20", "23", "13", "16", "19", "22"].map(item => {
										//splits the number with the colour letter
										const num = Number(item);
										let styles = "sl-bet " + (reds.indexOf(num) >= 0 ? "sl-red-lighten" : "sl-black-lighten");
										if (
											// && (this.state.activeHover.length === 5 || this.state.activeHover.split(",").length === 4)
											(this.state.activeHover.indexOf(item) >= 0 && this.state.activeHover.indexOf(" ") < 0) ||
											(this.state.activeHover === "2nd 12") ||
											(this.state.activeHover === "odd" && num % 2) ||
											(this.state.activeHover === "even" && !(num % 2)) ||
											(this.state.activeHover === "red" && reds.indexOf(num) >= 0) ||
											(this.state.activeHover === "black" && reds.indexOf(num) < 0) ||
											(this.state.activeHover === "1 to 18" && num <= 18) ||
											(this.state.activeHover === "19 to 36" && num >= 19) ||
											(this.state.activeHover === "3rd Row" && num % 3 === 0) ||
											(this.state.activeHover === "2nd Row" && num % 3 === 2) ||
											(this.state.activeHover === "1st Row" && num % 3 === 1))
											styles += " sl-bet-hover";
										if (win === +item)
											styles += " sl-yellow-alternating";

										return (
											<div key={`${item}+n`} className={styles}
												// bet={item} pcode={this.props.pcode} group="n"
												{...betGroupProp(this, item, "n")}
												onClick={this.props.insertBet}>
												{num}
												<Chips {...commonChipProps} betKey={item + "+n"} />
												<Tooltip {...commonTooltipProps} bet={this.props.bets[item + "+n"]} />
											</div>
										);
									})
								}
							</div>

							<div className="w-33">
								{
									["27", "30", "33", "36", "26", "29", "32", "35", "25", "28", "31", "34"].map(item => {
										//splits the number with the colour letter
										const num = Number(item);
										let styles = "sl-bet " + (reds.indexOf(num) >= 0 ? "sl-red-lighten" : "sl-black-lighten");
										if (
											//(this.state.activeHover.length === 5 || this.state.activeHover.split(",").length === 4 || this.state.activeHover.split(",").length === 3)
											(this.state.activeHover.indexOf(item) >= 0 && this.state.activeHover.indexOf(" ") < 0) ||
											(this.state.activeHover === "3rd 12") ||
											(this.state.activeHover === "odd" && num % 2) ||
											(this.state.activeHover === "even" && !(num % 2)) ||
											(this.state.activeHover === "red" && reds.indexOf(num) >= 0) ||
											(this.state.activeHover === "black" && reds.indexOf(num) < 0) ||
											(this.state.activeHover === "19 to 36" && num >= 19) ||
											(this.state.activeHover === "3rd Row" && num % 3 === 0) ||
											(this.state.activeHover === "2nd Row" && num % 3 === 2) ||
											(this.state.activeHover === "1st Row" && num % 3 === 1))
											styles += " sl-bet-hover";
										if (win === +item)
											styles += " sl-yellow-alternating";

										return (
											<div key={`${item}+n`} className={styles}
												// bet={item} pcode={this.props.pcode} group="n"
												{...betGroupProp(this, item, "n")}
												onClick={this.props.insertBet}>
												{num}
												<Chips {...commonChipProps} betKey={item + "+n"} />
												<Tooltip {...commonTooltipProps} bet={this.props.bets[item + "+n"]} />
											</div>
										);
									})
								}
							</div>
						</div>

						<div className="dp-flex">
							<div className={"w-33 sl-bet sl-green-old col-bet" + (win >= 1 && win <= 12 ? " sl-yellow-alternating" : "")}>
								1st 12
							<Chips {...commonChipProps} betKey="1st 12+n12" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["1st 12+n12"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, "1st 12", "n12")}
									// bet="1st 12" pcode={this.props.pcode} group="n12"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>
							<div className={"w-33 sl-bet sl-green-old col-bet" + ((win >= 13 && win <= 24) ? " sl-yellow-alternating" : "")}>
								2nd 12
							<Chips {...commonChipProps} betKey="2nd 12+n12" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["2nd 12+n12"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, "2nd 12", "n12")}
									// bet="2nd 12" pcode={this.props.pcode} group="n12"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>
							<div className={"w-33 sl-bet sl-green-old col-bet" + ((win >= 25 && win <= 36) ? " sl-yellow-alternating" : "")}>
								3rd 12
							<Chips {...commonChipProps} betKey="3rd 12+n12" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["3rd 12+n12"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, "3rd 12", "n12")}
									// bet="3rd 12" pcode={this.props.pcode} group="n12"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>
						</div>

						<div className="dp-flex bottom-bet">
							<div className={"w-24 sl-bet sl-green-old col-bet" + ((win > 0 && win <= 18) ? " sl-yellow-alternating" : "")}>
								{this.props.langdata["txt_1_to_18"]}
								<Chips {...commonChipProps} betKey="1 to 18+n50" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["1 to 18+n50"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, "1 to 18", "n50")}
									// bet="1 to 18" pcode={this.props.pcode} group="n50"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>

							<div className={"w-24 sl-bet sl-green-old col-bet" + ((win % 2) ? " sl-yellow-alternating" : "")}>
								{this.props.langdata["txt_odd"]}
								<Chips {...commonChipProps} betKey="odd+n50" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["odd+n50"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, "odd", "n50")}
									// bet="odd" pcode={this.props.pcode} group="n50"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>

							<div className={"sl-bet w-24 sl-green p7-medium red-button" + ((reds.indexOf(Number(win)) >= 0) ? " sl-yellow-alternating" : "")}>
								<div className="sl-red-lighten p7-diamond" />
								<Chips {...commonChipProps} betKey="red+n50" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["red+n50"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, "red", "n50")}
									// bet="red" pcode={this.props.pcode} group="n50"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>

							<div className={"sl-bet w-24 sl-green p7-medium black-button" + ((reds.indexOf(Number(win)) < 0 && win > 0) ? " sl-yellow-alternating" : "")}>
								<div className="sl-black-lighten p7-diamond" />
								<Chips {...commonChipProps} betKey="black+n50" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["black+n50"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, "black", "n50")}
									// bet="black" pcode={this.props.pcode} group="n50"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>

							<div className={"w-24 sl-bet sl-green-old col-bet" + (!(win % 2) && win > 0 ? " sl-yellow-alternating" : "")}>
								{this.props.langdata["txt_even"]}
								<Chips {...commonChipProps} betKey="even+n50" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["even+n50"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, "even", "n50")}
									// bet="even" pcode={this.props.pcode} group="n50"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>

							<div className={"w-24 sl-bet sl-green-old col-bet" + ((win >= 19 && win <= 36) ? " sl-yellow-alternating" : "")}>
								{this.props.langdata["txt_19_to_36"]}
								<Chips {...commonChipProps} betKey="19 to 36+n50" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["19 to 36+n50"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, "19 to 36", "n50")}
									// bet="19 to 36" pcode={this.props.pcode} group="n50"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>
						</div>
					</div>
					<div className="w-8 sides">
						<div className={"w-100 sl-bet sl-green-old trio" + ((win % 3 === 0 && win > 0) ? " sl-yellow-alternating" : "")}>
							<span>{this.props.langdata["txt_2_to_1"]}</span>
							<Chips {...commonChipProps} betKey="3rd Row+n12" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["3rd Row+n12"]} />
							<div className="sl-hover-hidden"
								{...betGroupProp(this, "3rd Row", "n12")}
								// bet="3rd Row" pcode={this.props.pcode} group="n12"
								onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
						</div>

						<div className={"w-100 sl-bet sl-green-old trio" + ((win % 3 === 2) ? " sl-yellow-alternating" : "")}>
							<span>{this.props.langdata["txt_2_to_1"]}</span>
							<Chips {...commonChipProps} betKey="2nd Row+n12" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["2nd Row+n12"]} />
							<div className="sl-hover-hidden"
								{...betGroupProp(this, "2nd Row", "n12")}
								// bet="2nd Row" pcode={this.props.pcode} group="n12"
								onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
						</div>

						<div className={"w-100 sl-bet sl-green-old trio" + ((win % 3 === 1) ? " sl-yellow-alternating" : "")}>
							<span>{this.props.langdata["txt_2_to_1"]}</span>
							<Chips {...commonChipProps} betKey="1st Row+n12" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["1st Row+n12"]} />
							<div className="sl-hover-hidden"
								{...betGroupProp(this, "1st Row", "n12")}
								// bet="1st Row" pcode={this.props.pcode} group="n12"
								onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
						</div>
					</div>
				</div>


				{/* DESKTOP & MOBILE LANDSCAPE MULTIBET */}
				{
					[
						["00,03", "03,06", "06,09", "09,12", "12,15", "15,18", "18,21", "21,24", "24,27", "27,30", "30,33", "33,36"],
						["00,02", "02,05", "05,08", "08,11", "11,14", "14,17", "17,20", "20,23", "23,26", "26,29", "29,32", "32,35"],
						["00,01", "01,04", "04,07", "07,10", "10,13", "13,16", "16,19", "19,22", "22,25", "25,28", "28,31", "31,34"]
					].map((row, rowIdx) =>
						row.map((groupComma, groupIdx) => {
							const firstPercent = this.props.maximised ? 8.2 : 6.5;
							const leftSpace = this.props.maximised ? 82 : 25;
							const width = this.props.maximised ? "8px" : "8px";

							return <div className={"sl-bet hidden"}
								key={`${groupComma}+n2`}
								style={{
									position: "absolute",
									left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
									top: "calc(3% + " + (rowIdx * 41) + "px)",
									background: multibetBackground,
									width: width,
									height: "28px"
								}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, groupComma, "n2")}
									// bet={groupComma} pcode={this.props.pcode} group="n2"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}

				{
					[
						["02,03", "05,06", "08,09", "11,12", "14,15", "17,18", "20,21", "23,24", "26,27", "29,30", "32,33", "35,36"],
						["01,02", "04,05", "07,08", "10,11", "13,14", "16,17", "19,20", "22,23", "25,26", "28,29", "31,32", "34,35"]
					].map((row, rowIdx) =>
						row.map((groupComma, groupIdx) => {
							const firstPercent = this.props.maximised ? 8.7 : 9;
							const leftSpace = this.props.maximised ? 82 : 25;
							const width = this.props.maximised ? "80px" : "20px";

							return <div className={"sl-bet hidden"}
								key={`${groupComma}+n2`}
								style={{
									position: "absolute",
									left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
									top: "calc(18% + " + (rowIdx * 41) + "px)",
									background: multibetBackground,
									width: width,
									height: "8px"
								}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, groupComma, "n2")}
									// bet={groupComma} pcode={this.props.pcode} group="n2"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}

				{
					[
						["02,03,05,06", "05,06,08,09", "08,09,11,12", "11,12,14,15", "14,15,17,18", "17,18,20,21", "20,21,23,24", "23,24,26,27", "26,27,29,30", "29,30,32,33", "32,33,35,36"],
						["01,02,04,05", "04,05,07,08", "07,08,10,11", "10,11,13,14", "13,14,16,17", "16,17,19,20", "19,20,22,23", "22,23,25,26", "25,26,28,29", "28,29,31,32", "31,32,34,35"]
					].map((row, rowIdx) =>
						row.map((groupComma, groupIdx) => {
							const firstPercent = this.props.maximised ? 15.1 : 13.5;
							const leftSpace = this.props.maximised ? 82 : 25;
							const width = this.props.maximised ? "8px" : "8px";

							return <div className={"sl-bet hidden"}
								key={`${groupComma}+n4`}
								style={{
									position: "absolute",
									left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
									top: "calc(15% + " + (rowIdx * 41) + "px)",
									background: multibetBackground,
									width: width,
									height: "20px"
								}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n4"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n4"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, groupComma, "n4")}
									// bet={groupComma} pcode={this.props.pcode} group="n4"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}

				{
					[
						["01,02,03", "04,05,06", "07,08,09", "10,11,12", "13,14,15", "16,17,18", "19,20,21", "22,23,24", "25,26,27", "28,29,30", "31,32,33", "34,35,36"]
					].map((row, rowIdx) =>
						row.map((groupComma, groupIdx) => {
							const firstPercent = this.props.maximised ? 8.7 : 9;
							const leftSpace = this.props.maximised ? 82 : 25;
							const width = this.props.maximised ? "80px" : "20px";

							return <div className={"sl-bet hidden"}
								key={`${groupComma}+n3`}
								style={{
									position: "absolute",
									left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
									top: "calc(-1% + " + (rowIdx * 41) + "px)",
									background: multibetBackground,
									width: width,
									height: "8px"
								}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n3"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n3"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, groupComma, "n3")}
									// bet={groupComma} pcode={this.props.pcode} group="n3"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}

				{
					[
						["00,02,03"],
						["00,01,02"]
					].map((row, rowIdx) =>
						row.map((groupComma, groupIdx) => {
							const firstPercent = this.props.maximised ? 8.2 : 6.5;
							const leftSpace = this.props.maximised ? 82 : 25;
							const width = this.props.maximised ? "8px" : "8px";

							return <div className={"sl-bet hidden"}
								key={`${groupComma}+n3`}
								style={{
									position: "absolute",
									left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
									top: "calc(15% + " + (rowIdx * 41) + "px)",
									background: multibetBackground,
									width: width,
									height: "20px"
								}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n3"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n3"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, groupComma, "n3")}
									// bet={groupComma} pcode={this.props.pcode} group="n3"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}

				{
					[
						["01,02,03,04,05,06", "04,05,06,07,08,09", "07,08,09,10,11,12", "10,11,12,13,14,15", "13,14,15,16,17,18", "16,17,18,19,20,21", "19,20,21,22,23,24", "22,23,24,25,26,27", "25,26,27,28,29,30", "28,29,30,31,32,33", "31,32,33,34,35,36"]
					].map((row, rowIdx) =>
						row.map((groupComma, groupIdx) => {
							const firstPercent = this.props.maximised ? 15.1 : 13.5;
							const leftSpace = this.props.maximised ? 82 : 25;
							const width = this.props.maximised ? "8px" : "8px";

							return <div className={"sl-bet hidden"}
								key={`${groupComma}+n6`}
								style={{
									position: "absolute",
									left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
									top: "calc(-1% + " + (rowIdx * 41) + "px)",
									background: multibetBackground,
									width: width,
									height: "8px"
								}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n6"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n6"]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, groupComma, "n6")}
									// bet={groupComma} pcode={this.props.pcode} group="n6"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}
			</div>
		);
	}
}
